import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function CartaNatalSection() {
  return <section className="py-12 px-4 bg-gradient-to-b from-cream-50 to-cream-100 relative overflow-hidden" data-id="element-1">
      {/* Decorative glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-gold-200/15 rounded-full blur-3xl" data-id="element-2" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-3">
        <FadeIn data-id="element-4">
          <div className="bg-white rounded-3xl border-2 border-gold-300/40 shadow-xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-5">
            {/* Corner accent */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold-100/50 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-6" />

            <motion.div animate={{
            rotate: [0, 10, -10, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center justify-center w-16 h-16 bg-gold-100 rounded-full mb-5 border border-gold-200 shadow-inner" data-id="element-7">
              <Sparkles className="w-8 h-8 text-gold-500" data-id="element-8" />
            </motion.div>

            <h2 className="text-2xl md:text-3xl font-bold text-burgundy-900 mb-4 leading-tight" data-id="element-9">
              ¿No sabés hacer una carta natal?
              <br data-id="element-10" />
              <span className="text-gold-500" data-id="element-11">¡No te preocupes!</span>
            </h2>

            <p className="text-lg text-burgundy-700 leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-12">
              Dentro del pack te enseñamos{' '}
              <span className="font-bold text-burgundy-900" data-id="element-13">paso a paso</span>{' '}
              cómo crear la carta natal de tu hijo de forma simple y gratuita.
            </p>

            <p className="text-base text-burgundy-600 leading-relaxed max-w-2xl mx-auto" data-id="element-14">
              Solo necesitás saber la{' '}
              <span className="font-bold" data-id="element-15">
                fecha, hora y lugar de nacimiento
              </span>
              . Con eso y nuestra guía incluida, vas a poder armar la carta
              natal en minutos — sin conocimientos previos, sin pagar nada
              extra.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}